var map = {
	"./apfelstrudel.jpg": 5211,
	"./baguette.jpg": 6394,
	"./brathahnchen.jpg": 1999,
	"./bretzel.jpg": 8306,
	"./currywurst.jpg": 5410,
	"./donut.jpg": 540,
	"./eis.jpg": 9651,
	"./eisbein.jpg": 5453,
	"./fishchips.jpg": 9364,
	"./hackbraten.jpg": 3098,
	"./lasagne.jpg": 9839,
	"./place1.jpg": 6010,
	"./place2.jpg": 29,
	"./place3.jpg": 2178,
	"./place4.jpg": 9661,
	"./place5.jpg": 8898,
	"./place6.jpg": 7001,
	"./pudding.jpg": 8291,
	"./ramen.jpg": 3439,
	"./ratatouille.jpg": 8568,
	"./sauergurken.jpg": 9079,
	"./sauerkraut.jpg": 995,
	"./schnitzel.jpg": 1567,
	"./yakisoba.jpg": 4083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9221;